import '../../styles/web-components/loading-spinner.scss';
const DEFAULT_TIMEOUT = 10000;
class LoadingSpinner extends HTMLElement {
    static get observedAttributes() {
        return ["show"];
    }
    constructor() {
        super();
    }
    timeoutId;
    connectedCallback() {
        this.render();
        if (this.getAttribute("show") !== "false") {
            this.setAttribute("show", "true");
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue)
            return;
        switch (name) {
            case 'show':
                this.updateDisplay(newValue);
                break;
        }
    }
    disconnectedCallback() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }
    updateDisplay(bool) {
        const container = this.querySelector('.loading-spinner__container');
        if (container) {
            if (bool === "true") {
                container.style.display = 'flex';
                this.timeoutId = window.setTimeout(() => {
                    this.setAttribute('show', 'false');
                }, +this.getAttribute('timeout') || DEFAULT_TIMEOUT);
            }
            else {
                container.style.display = 'none';
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                }
            }
        }
    }
    render() {
        this.innerHTML = `
      <div class="loading-spinner__container ${this.getAttribute('blocking') === "true" ? 'loading-spinner__container--block' : ''}" style="display: none;">
        <div class="loading-spinner__spinner"></div>
      </div>
    `;
    }
}
if (!window.customElements.get("loading-spinner")) {
    customElements.define("loading-spinner", LoadingSpinner);
}
